import Vuex from 'vuex'

const store = new Vuex.Store({
    state: {
        track_page: false,
        show_intro: true,
        is_loading: false,
        page: null,
        social: {
            instagram: 'https://www.instagram.com/grappleagency/',
            facebook: 'https://www.facebook.com/GrappleAgency/',
            twitter: 'https://twitter.com/grappleagency',
            medium: 'http://medium.com',
            exposure: 'https://grapple.exposure.co/'
        },
        footer: {
            is_active: true,
        }
    },
    mutations: {
        UPDATE_PAGE(state, page) {
            state.page = page;
        },
        UPDATE_TRACK_PAGE(state, status) {
            state.track_page = status;
        },
        UPDATE_LOADING_STATUS(state, status) {
            state.is_loading = status;
        },
        UPDATE_INTRO_STATUS(state, status) {
            state.show_intro = status;
        }
    },
    actions: {
        updatePage(context, page) {
            context.commit('UPDATE_PAGE', page );

            var url = '';
            
            if( page.link !== undefined ) {
                url = page.link;
                url = url.replace( window.location.origin, "" );
            }

            let title = htmlDecode(page.title.rendered);
            let description = '';

            axios.get('/wp-json/grpl/v1/yoast/'+page.id).then(response => {
                if(response.data.title !== undefined && response.data.title.length > 0){
                    title = htmlDecode(response.data.title);
                }
                if( ( response.data.description !== undefined && response.data.description.length > 0 ) ){
                    description = response.data.description;
                    $('meta[name=description]').remove();
                    $('head').append( '<meta name="description" content="'+description+'">' );
                }

                title = title.replace(' | Grapple', '');

                document.title = title + ' | Grapple';

            })
            .catch( (error) => {});

            if( context.state.is_loading === false ) {
                if( $('html').hasClass('activemenu') ) {
                    Animations.pageReset(true);
                } else {
                    Animations.pageReset();
                }
            }

            if( context.state.track_page === false ) {
                context.commit('UPDATE_TRACK_PAGE', true );
            }

            if( context.state.track_page === true ) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Pageview',
                    'pagePath': url,
                    'pageTitle': page.title.rendered
                });
            }

        },
        isLoading( context, status ) {
            context.commit('UPDATE_LOADING_STATUS', status);
        },
        updateIntro( context, status ) {
            context.commit('UPDATE_INTRO_STATUS', status);
        }
    },
});

export default store;

function htmlDecode(value) {
    return $("<textarea/>").html(value).text();
}